<template>
  <v-card tile v-if="employee !== null">
    <v-card-title>
      <v-row>
        <v-col cols="12" xl="8">
          <span
            >Transakcije zaposlenega {{ employee.first_name }}
            {{ employee.last_name }}</span
          >
        </v-col>
      </v-row>
    </v-card-title>
    <v-card-text>
      <h2 style="padding: 30px 0">
        Trenutno stanje: {{ employeeMoney.total }} €
      </h2>
      <v-data-table
        :headers="headers"
        :items="employeeMoney.transactions.data"
        :page.sync="employeeMoney.transactions.current_page"
        :items-per-page="employeeMoney.transactions.per_page"
        :server-items-length="employeeMoney.transactions.total"
        :options.sync="tableOptions"
        @update:options="loadEmployeeMoney"
        :footer-props="{
          itemsPerPageOptions: [10, 25, 50],
        }"
        sort-by="id"
        class="elevation-1"
        :single-expand="true"
        :expanded.sync="expanded"
        show-expand
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              @click="
                $router.push({
                  name: 'EmployeeMoneyCreate',
                  params: { employee_id: employee.id },
                })
              "
            >
              Dodaj
            </v-btn>
          </v-toolbar>
        </template>
        <template v-slot:[`item.created_at`]="{ item }">
          {{ $moment(item.created_at).format("DD.MM.YYYY HH:mm") }}
        </template>
        <template v-slot:[`item.value`]="{ item }">
          {{ item.value }} €
        </template>
        <template v-slot:[`item.user_id`]="{ item }">
          {{ item.user ? item.user.name : "" }}
        </template>
        <template v-slot:[`item.money_type_id`]="{ item }">
          {{ item.money_type ? item.money_type.name : "" }}
        </template>
        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length" style="padding: 20px">
            {{ item.notes }}
          </td>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <TooltipIconButton
            tooltip="Uredi"
            icon="mdi-pencil"
            @click="
              $router.push({
                name: 'EmployeeMoneyItem',
                params: { employee_id: employee.id, id: item.id },
              })
            "
          ></TooltipIconButton>
          <TooltipIconButton
            tooltip="Izbriši"
            icon="mdi-delete"
            @click="remove(item)"
          ></TooltipIconButton>
        </template>
        <template v-slot:no-data>
          <v-btn color="primary" @click="loadEmployeeMoney">Reset</v-btn>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>
<script>
  import TooltipIconButton from "@/components/TooltipIconButton.vue";

  export default {
    data: () => ({
      expanded: [],
      employee: null,
      employeeMoney: {
        total: 0,
        transactions: { data: [] },
      },
      headers: [
        { text: "Tip", value: "money_type_id" },
        { text: "Vrednost", value: "value" },
        { text: "Datum", value: "created_at" },
        { text: "Administrator", value: "user_id" },
        { text: "", value: "actions" },
        { text: "", value: "data-table-expand" },
      ],
      tableOptions: {
        page: 1,
        itemsPerPage: 10,
        sortBy: ["created_at"],
        sortDesc: [true],
      },
    }),
    mounted() {
      this.loadEmployee();
      this.loadEmployeeMoney();
    },
    methods: {
      loadEmployee() {
        this.$http
          .get("api/v1/employees/" + this.$route.params.employeeId)
          .then((response) => {
            this.employee = response.data;
          })
          .catch(() => {
            this.$router.push({ name: "Employees" });
          });
      },
      loadEmployeeMoney() {
        let orderBy = {};
        if (
          this.tableOptions.sortBy.length > 0 &&
          this.tableOptions.sortDesc.length > 0
        ) {
          orderBy[this.tableOptions.sortBy[0]] =
            this.tableOptions.sortDesc[0] === true ? "desc" : "asc";
        }
        let params = {
          page: this.tableOptions.page,
          perPage: this.tableOptions.itemsPerPage,
          orderBy,
        };
        this.$http
          .get("api/v1/employees/" + this.$route.params.employeeId + "/money", {
            params,
          })
          .then((response) => {
            this.employeeMoney = response.data;
          });
      },
      remove(item) {
        this.$swal({
          title: "Pozor",
          text: "Ali ste prepričani da želite izbrisati transakcijo",
          type: "warning",
          confirmButtonText: "Izbriši",
          cancelButtonText: "Prekliči",
          showCancelButton: true,
        }).then((value) => {
          if (value.value !== true) {
            return;
          }
          this.$http.delete("api/v1/money/" + item.id).then(() => {
            this.loadEmployeeMoney();
          });
        });
      },
    },
    components: {
      TooltipIconButton,
    },
  };
</script>
<style></style>
